import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { CardTypeThree } from "../../Common/Cards";
import { languageService } from "../../../Language/language.service";
import moment from "moment";
import { getStatusColor } from "../../../utils/statusColors";
import { CRUDFunction } from "../../../reduxCURD/container";
import { deriveCRUDNames } from "../crudHelpers";
import { themeService } from "../../../theme/service/activeTheme.service";
import { commonStylesDashboard } from "../../Dashboard/styles/commonStylesDashboard";
import PropagateLoader from "react-spinners/PropagateLoader";
class InspectionSummaryWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widgetData: null,
      spinnerLoading: false,
    };
    this.getCombinedData = this.getCombinedData.bind(this);
    this.fetchCall = this.fetchCall.bind(this);
  }

  fetchCall(settings, dateRange, filterLocations) {
    let sett = settings.map((s) => {
      return { ...s, lineIds: filterLocations };
    });
    // const url = `summary?settings=${JSON.stringify(sett)}&dateRange=${JSON.stringify(dateRange)}`;

    // this.props.getInspectionSummaryWidgets(url);
    this.props.createInspectionSummaryWidget(
      {
        settings: sett,
        dateRange: dateRange,
      },
      "WidgetSettings",
      "/summary",
    );
  }

  componentDidMount() {
    const { settings } = this.props.settings;
    const { dateRange, filterLocations } = this.props;

    this.fetchCall(settings, dateRange, filterLocations);
  }

  componentDidUpdate(prevProps) {
    const {
      settings: { settings },
      dateRange,
      actionType,
      filterLocations,
      inspectionSummaryWidgets,
    } = this.props;

    const { dateRange: prevDateRange, actionType: prevActionType, filterLocations: prevFilterLocations } = prevProps;

    if (filterLocations !== prevFilterLocations) {
      this.fetchCall(settings, dateRange, filterLocations);
    }

    const dateChanged = dateRange.month !== prevDateRange.month || dateRange.year !== prevDateRange.year;
    if (dateChanged) {
      this.fetchCall(settings, dateRange, filterLocations);
    }

    // Handle action type changes
    switch (actionType) {
      case "INSPECTIONSUMMARYWIDGET_CREATE_REQUEST":
        if (actionType !== prevActionType) {
          this.setState({ spinnerLoading: true });
        }
        break;

      case "INSPECTIONSUMMARYWIDGET_CREATE_SUCCESS":
        if (actionType !== prevActionType) {
          this.setState({
            widgetData: inspectionSummaryWidgets,
            spinnerLoading: false,
          });
        }
        break;

      case "INSPECTIONSUMMARYWIDGET_CREATE_FAILURE":
        if (actionType !== prevActionType) {
          console.error("Failed to fetch widget data.");
          this.setState({ spinnerLoading: false });
        }
        break;

      default:
        break;
    }
  }

  getCombinedData() {
    const { widgetData } = this.state;
    let inspectionSummary = widgetData ? widgetData.inspectionSummary : {};
    let summary = {
      total: 0,
      inProgress: 0,
      issuesReported: 0,
    };

    if (inspectionSummary && inspectionSummary.lines) {
      Object.entries(inspectionSummary.lines).forEach(([id, val]) => {
        summary.total += val.summary.total;
        summary.inProgress += val.summary.inProgress;
        summary.issuesReported += val.summary.issuesReported;
      });
    }

    return summary;
  }

  render() {
    let data = this.getCombinedData();
    const { widgetData, spinnerLoading } = this.state;

    if (spinnerLoading || !widgetData) {
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 150 }}>
          <PropagateLoader
            color={themeService({ default: "rgb(55, 139, 119)", retro: "var(--first)", electric: "rgba(64, 118, 179,.5)" })}
            sizeUnit={"px"}
            size={10}
          />
        </div>
      );
    }
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <Row style={themeService(commonStylesDashboard.summaryHeading)}>{languageService("Inspections")}</Row>
        </div>
        <Row style={{ gap: "20px", paddingInline: "15px" }}>
          <Col style={{ padding: 0, margin: 0 }}>
            <CardTypeThree number={data.total} numberColor={getStatusColor("Completed")} text={languageService("Performed")} />
          </Col>
          <Col style={{ padding: 0, margin: 0 }}>
            <CardTypeThree number={data.inProgress} numberColor={getStatusColor("In Progress")} text={"In Progress"} />
          </Col>
          <Col style={{ padding: 0, margin: 0 }}>
            <CardTypeThree number={data.issuesReported} numberColor={getStatusColor("Missed")} text={"Issues Reported"} />
          </Col>
        </Row>
      </div>
    );
  }
}

const actionOptions = {
  create: true,
  update: false,
  read: true,
  delete: false,
};

const InspectionSummaryWidgetContainer = CRUDFunction(
  InspectionSummaryWidget,
  "inspectionSummaryWidget",
  actionOptions,
  null,
  [],
  "dashboard",
);

export default InspectionSummaryWidgetContainer;



// WEBPACK FOOTER //
// ./src/components/NewDashboard/widgets/InspectionSummaryWidget.jsx